import styles from "./ProductOption.module.scss";

export const formatProductOption = (option) => (
	<span className={styles.productOption}>
		<span className={`${styles.productBadge} ${option.generic ? styles.productBadgeGeneric : styles.productBadgeLabeled}`}>
			{option.generic ? "G" : "E"}
		</span>
		{option.label}
	</span>
);
